/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. Original work by Solvetia — part of the Solvetia
 * white-label additions to Chatwoot Community Edition (MIT). Not derived from
 * the commercial code under enterprise/.
 */
const BRAND_COLOR_VAR = '--dynamic-brand-color';

/**
 * Converts a #RRGGBB hex string to a space-separated "r g b" triplet,
 * the format Tailwind's rgb(var(--x) / <alpha>) expects. Returns null
 * when the input is not a valid 6-digit hex color.
 */
export const hexToRgbTriplet = hex => {
  if (typeof hex !== 'string') return null;
  const match = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!match) return null;
  const int = parseInt(match[1], 16);
  // eslint-disable-next-line no-bitwise
  return `${(int >> 16) & 255} ${(int >> 8) & 255} ${int & 255}`;
};

/**
 * Sets the accent color CSS variable on :root. When hex is null/invalid,
 * removes the override so the default from CSS (--dynamic-brand-color in
 * _base.scss) takes over.
 */
export const applyBrandColor = hex => {
  const triplet = hexToRgbTriplet(hex);
  const root = document.documentElement;
  if (triplet) {
    root.style.setProperty(BRAND_COLOR_VAR, triplet);
  } else {
    root.style.removeProperty(BRAND_COLOR_VAR);
  }
};

/**
 * Points all <link class="favicon"> elements to the given url. When url is
 * null, restores the default per-size favicons (/favicon-<size>.png).
 */
export const applyFavicon = url => {
  const favicons = document.querySelectorAll('link.favicon');
  favicons.forEach(favicon => {
    if (url) {
      favicon.href = url;
    } else {
      const size = favicon.getAttribute('sizes') || '32x32';
      favicon.href = `/favicon-${size}.png`;
    }
  });
};
